import {MONITORED_URI_REFERENCE_VALUE_UPDATED} from "../actions/monitoredUri";

export const CURRENT_MONITORED_URI_FETCHED = "CURRENT_MONITORED_URI_FETCHED";
export const CURRENT_MONITORED_URI_PERFORMANCES_FETCHED = "CURRENT_MONITORED_URI_PERFORMANCES_FETCHED";
export const CURRENT_MONITORED_URI_SEARCH_PERFORMANCES_FETCHED = "CURRENT_MONITORED_URI_SEARCH_PERFORMANCES_FETCHED";
export const CURRENT_MONITORED_URI_INBOUND_LINKS_FETCHED = "CURRENT_MONITORED_URI_INBOUND_LINKS_FETCHED";
export const CURRENT_MONITORED_URI_SNAPSHOT_FETCH_STARTED = "CURRENT_MONITORED_URI_SNAPSHOT_FETCH_STARTED";
export const CURRENT_MONITORED_URI_SNAPSHOT_FETCH_SUCCESS = "CURRENT_MONITORED_URI_SNAPSHOT_FETCH_SUCCESS";
export const CURRENT_MONITORED_URI_SNAPSHOT_FETCH_404 = "CURRENT_MONITORED_URI_SNAPSHOT_FETCH_404";
export const CURRENT_MONITORED_URI_SNAPSHOT_FETCH_FAILED = "CURRENT_MONITORED_URI_SNAPSHOT_FETCH_FAILED";
export const CURRENT_MONITORED_URI_CHANGES_FETCHED = "CURRENT_MONITORED_URI_CHANGES_FETCHED";
export const CURRENT_MONITORED_SELECT_SNAPSHOT = "CURRENT_MONITORED_SELECT_SNAPSHOT";
export const CURRENT_MONITORED_URI_CHANGED = "CURRENT_MONITORED_URI_CHANGED";
export const CURRENT_MONITORED_URI_CHART_FILTERS_SET = "CURRENT_MONITORED_URI_CHART_FILTERS_SET";


export const IN_PROGRESS = "IN_PROGRESS";
export const COMPLETED = "COMPLETED";
export const ERROR_404 = "ERROR_404";
export const ERROR = "ERROR";

export const DEFAULT_HIDDEN_SERIES = ['clicks', 'position'];

const initialState = {
    // The chart's hidden series and change-type filter, out of the URL so moving between pages is one
    // Back press rather than one per toggle.
    chartFilters: { hiddenSeries: DEFAULT_HIDDEN_SERIES, changeTypes: [] },
    numDaysHistory: 366,
    curSnapshotIndex: -1,
    pageSnapshotsMap: {},
    pageChanges: [],
    pagePerformances: [],
    pageSearchPerformances: [],
    inboundLinks: {content: []},
    lastCrawl: {},
    currentValue: {
        "uri": "",
        "time": 0,
        "title": "",
        "h1s": [],
        "h2s": [],
        "metaDescriptions": [],
        "canonicals": []
    },
    recommendation: {
        "uri": "",
        "time": 0,
        "title": "",
        "h1s": [],
        "h2s": [],
        "metaDescriptions": [],
        "canonicals": []
    }

};


export default (state = initialState, action) => {
    // console.debug("Current Monitored Uri Event:", action)
    // console.debug("State", state)
    switch (action.type) {

        case MONITORED_URI_REFERENCE_VALUE_UPDATED:
            if (action.monitoredUriId === state.id) {
                let newRef = Object.assign({}, state.recommendation, action.newValue);
                return Object.assign({}, state, {recommendation: newRef});
            }
            return state;

        case CURRENT_MONITORED_URI_CHANGED:
            return Object.assign({}, initialState);

        case CURRENT_MONITORED_URI_CHART_FILTERS_SET:
            return Object.assign({}, state, {chartFilters: Object.assign({}, state.chartFilters, action.payload)});

        case CURRENT_MONITORED_SELECT_SNAPSHOT:
            return Object.assign({}, state, {
                curSnapshotDate: action.curSnapshotDate,
                lastCrawl: initialState.lastCrawl
            });
        case CURRENT_MONITORED_URI_CHANGES_FETCHED:
            return Object.assign({}, state, {pageChanges: action.payload});

        case CURRENT_MONITORED_URI_INBOUND_LINKS_FETCHED:
            return Object.assign({}, state, {inboundLinks: action.payload.inboundLinks});


        case CURRENT_MONITORED_URI_SNAPSHOT_FETCH_STARTED:

            return Object.assign({}, state, {
                    pageSnapshotsMap: updatePageSnapshotMap(state, action.curSnapshotDate, {fetchStatus: IN_PROGRESS})
                }
            );

        case CURRENT_MONITORED_URI_SNAPSHOT_FETCH_404:
            return Object.assign({}, state, {
                    pageSnapshotsMap: updatePageSnapshotMap(state, action.curSnapshotDate, {fetchStatus: ERROR_404})
                }
            );

        case CURRENT_MONITORED_URI_SNAPSHOT_FETCH_FAILED:
            return Object.assign({}, state, {
                    pageSnapshotsMap: updatePageSnapshotMap(state, action.curSnapshotDate, {fetchStatus: ERROR})
                }
            );

        case CURRENT_MONITORED_URI_SNAPSHOT_FETCH_SUCCESS:
            return Object.assign({}, state, {
                    pageSnapshotsMap: updatePageSnapshotMap(state, action.curSnapshotDate, {
                        ...action.value,
                        fetchStatus: COMPLETED
                    })
                }
            );

        case CURRENT_MONITORED_URI_PERFORMANCES_FETCHED:

            return Object.assign({}, state, {
                pagePerformances: addElementToArray(state.pagePerformances, action.payload)
            });

        case CURRENT_MONITORED_URI_SEARCH_PERFORMANCES_FETCHED:
            return Object.assign({}, state, {pageSearchPerformances: action.payload});

        case CURRENT_MONITORED_URI_FETCHED:
            if (!action.payload.recommendation) action.payload.recommendation = {};

            let curSnapshotDate = new Date().toISOString().split("T")[0];

            const currentValuePresent = action.payload.currentValue;

            if (currentValuePresent) {
                currentValuePresent.lastCrawl = action.payload.lastCrawl;
            }
            action.payload.lastCrawl = undefined; //avoiding depending on value that is not present for previous snapshots

            if (currentValuePresent) {
                curSnapshotDate = new Date(currentValuePresent.createDate).toISOString().split("T")[0];
            }

            return Object.assign({}, state, {
                    ...action.payload,
                    lastSnapshotDate: curSnapshotDate,
                    curSnapshotDate: curSnapshotDate,
                    pageSnapshotsMap: updatePageSnapshotMap(state, curSnapshotDate,
                        {
                            ...currentValuePresent,
                            crawlScope: action.payload.crawlScope,
                            fetchStatus: currentValuePresent ? COMPLETED : ERROR_404
                        }
                    )
                }
            );
        default:
            return state
    }
}

function updatePageSnapshotMap(state, dateString, value) {
    //dateString format: 2019-01-01
    return {
        ...state.pageSnapshotsMap, [dateString]: value
    };
}

function addElementToArray(array, value) {
    return [
        ...array, value
    ]
}


